import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const updateRoute = createAsyncThunk("updateRoute", async ({ values }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.put(`routes`, values);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const UpdateRouteSlice = createSlice({
	name: "UpdateRouteSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetUpdateRouteState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(updateRoute.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(updateRoute.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(updateRoute.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetUpdateRouteState } = UpdateRouteSlice.actions;
export default UpdateRouteSlice.reducer;
